import { AutoFixHigh, Spellcheck, Summarize } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { EditorContent, useCurrentEditor } from '@tiptap/react';

function MeetingTiptapContent() {
  const { editor } = useCurrentEditor();
  const theme = useTheme();

  if (!editor) return null;

  return (
    <EditorContent
        editor={editor}
        style={{
          color: theme.palette.text.primary,
        }}
        width="100%"
       />
  );
}

export default MeetingTiptapContent;
